import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import BrowserHelper from 'src/app/helpers/browser-helper';
import ProjectContact from 'src/app/model/company/projectContact';
import IPBoard from 'src/app/model/product/ip-board/ip-board';
import { Adjustment } from 'src/app/model/project/adjustment';

@Component({
  selector: 'client-adjustment-design-collapse',
  templateUrl: './client-adjustment-design-collapse.component.html',
  styleUrls: ['./client-adjustment-design-collapse.component.scss'],
})
export class ClientAdjustmentDesignCollapseComponent implements OnInit {
  @Input()
  projectId: number;

  @Input()
  ipBoard: IPBoard;

  @Input()
  projectContacts: ProjectContact[];

  @Input()
  adjustment: Adjustment;

  @Input()
  designCollapsed: boolean = true;

  @Output()
  save = new EventEmitter();

  safari: boolean;

  designCollapsedInternal: boolean = false;

  constructor() {}

  ngOnInit(): void {
    this.safari = BrowserHelper.isSafari();
    this.designCollapsedInternal = this.designCollapsed;
  }
}
